import { Component, inject, OnInit } from '@angular/core';
import { MercuryService } from '../../services/mercury.service';
import { UserTrackerConsent } from '../../models/userTrackConsent.model';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { ConsentTimelineComponent } from '../../components/consent-timeline/consent-timeline.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { NgIf, NgForOf, NgClass } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OptInOutModel } from '../../models/optInOut.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { catchError, forkJoin, of, switchMap } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NoRecordFoundComponent } from '../../components/no-record-found/no-record-found.component';
import { HttpErrorResponse } from '@angular/common/http';
import { PolicyHolder } from '../../models/policyHolder.model';
import { PolicyHolderDetailsComponent } from '../../components/policy-holder-details/policy-holder-details.component';
import { EnablingNewChannelModalComponent } from '../../components/enabling-new-channel-modal/enabling-new-channel-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

import { GlobalLoadingService } from '../../services/global-loading.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { AuthStateService } from '../../services/auth-state.service';
import { TenantGuardService } from '../../services/tenant-guard.services';
import { ForbiddenPageComponent } from '../forbidden-page/forbidden-page.component';
import { DomainContextService } from '../../services/domain-context.service';

@Component({
  selector: 'app-search-page',
  imports: [
    ReactiveFormsModule, 
    ConsentTimelineComponent, 
    MatCardModule, 
    MatFormFieldModule, 
    MatInputModule, 
    MatButtonModule, 
    NgIf, 
    NgForOf, 
    MatSlideToggleModule, 
    NgClass, 
    FormsModule, 
    MatProgressSpinnerModule, 
    MatIconModule,
    NoRecordFoundComponent,
    PolicyHolderDetailsComponent,
    ForbiddenPageComponent
  ],
  templateUrl: './search-page.component.html',
  styleUrl: './search-page.component.scss'
})
export class SearchPageComponent implements OnInit{
  
  private mercuryServices = inject(MercuryService)
  private snackBar = inject(MatSnackBar)
  private dialog = inject(MatDialog)
  private msalService = inject(MsalService)
  private globalLoadingService = inject(GlobalLoadingService)
  private messageService = inject(GlobalMessageService)
  private auth = inject(AuthStateService)
  private tenantGuard = inject(TenantGuardService)
  private domainService = inject(DomainContextService)

  toggleValue: boolean = false
  listUserTrackConsent: UserTrackerConsent[] = []

  listCurrentStatus: UserTrackerConsent[] = []
  matchLevel: string = ''
  enableNoRecordsFound: boolean = false
  isLoading = false;

  form: FormGroup;
  isSaving: boolean = false
  policyHolder!: PolicyHolder | null
  account! : AccountInfo

  private scrollPosition = 0;

  saveAndReload() {

    this.scrollPosition = window.scrollY || window.pageYOffset;

    this.saveChanges();
  }

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      searchValue: ['', Validators.required]
    });
  }
 
  ngOnInit(): void {

    this.account = this.msalService.instance.getAllAccounts()[0];

    this.form.get('searchValue')!.valueChanges.subscribe((x) => {
      
      // this.listUserTrackConsent = [];
      // this.listCurrentStatus = []
      this.matchLevel = this.checkMatchLevel(x)
    });
  }

  getChannelIcon(channel: string): string {
    
    switch (channel.toUpperCase()) {
      case 'SMS': return 'sms';
      case 'CALL': return 'call';
      case 'MAIL': return 'alternate_email';
      default: return 'help';
    }
  }

  get hasChangedItems(): boolean {

  return this.listCurrentStatus.some(item =>
    (item.Action === 'OptOut' && item.IsOptOut == false) ||
    (item.Action === 'OptIn'  && item.IsOptOut === true)
  );
  }

  transformToLowercase(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value.toLowerCase();
    
    this.form.controls['searchValue'].setValue(value, { emitEvent: false });
    input.value = value; 
  }

  listRecords() {

    if(this.form.invalid){
      return
    }

    this.enableNoRecordsFound = false
    this.isLoading = true;
    console.log(this.form.value.searchValue);
    this.listUserTrackConsent = []
    this.listCurrentStatus = []
    this.policyHolder = null

    var byportfolioOptions = ["policy code","client code"] 
    
    if(byportfolioOptions.includes(this.matchLevel)){

      this.mercuryServices.getCustomerByPortfolioCode(this.form.controls['searchValue'].value?.substring(0,6)).subscribe({

        next: res=>{

          this.policyHolder = res
         
          if(res.MobilePhoneNumber)
          this.mercuryServices.getHistory(res.MobilePhoneNumber).subscribe({
            next: (res=>{
              this.listUserTrackConsent.push(...res)
              this.getChannels()
              this.isLoading = false
            
              if(this.listUserTrackConsent.length < 0){
                this.enableNoRecordsFound = true
              }
            }),
            error: (err: HttpErrorResponse)=>{
             
              this.getChannels()
              console.error(err)
              this.isLoading = false

              if (err.status === 404) {
                this.isLoading = false
                this.enableNoRecordsFound = true

               

              } else if (err.status === 500) {
                console.log('Server error.');
                this.isLoading = false
                this.enableNoRecordsFound = true
                this.messageService.showError('Something went wrong. Please try again.')
              }

               if(this.listUserTrackConsent.length < 0){
                  this.enableNoRecordsFound = true
              }
             
            }
          })

          if(res.Email)
            this.mercuryServices.getHistory(res.Email).subscribe({
              next: (res=>{
                this.listUserTrackConsent.push(...res)
                this.getChannels()
                this.isLoading = false

                if(this.listUserTrackConsent.length < 0){
                  this.enableNoRecordsFound = true
                }
              }),
              error: err =>{
                this.getChannels()
                console.error(err)
                if(this.listUserTrackConsent.length < 0){
                  this.enableNoRecordsFound = true
                }
              }
            })
        },
        error: (error: HttpErrorResponse)=>{
          this.isLoading = false
          this.getChannels()
          console.log(error.status)
          this.messageService.showError('Something went wrong. Please try again.')
        }

      })

    }
    else{
      this.mercuryServices.getHistory(this.form.controls['searchValue'].value).subscribe({
          next: (res) =>{
      
            if(res.length < 0){
              this.enableNoRecordsFound = true
            }

            this.listUserTrackConsent = res

            this.getChannels()

            this.isLoading = false
          },
          error: (error: HttpErrorResponse)=>{
            this.getChannels()
            console.log('HTTP Status:', error.status);
            this.messageService.showError('Something went wrong. Please try again.')

              if (error.status === 404) {
                this.isLoading = false
                this.enableNoRecordsFound = true
              } else if (error.status === 500) {
                console.log('Server error.');
                this.isLoading = false
                this.enableNoRecordsFound = true
              }
          }
        })
    }
  }

  get currentStatus() {

    return this.listUserTrackConsent
      .slice()
      .sort((a, b) => new Date(b.DateTime).getTime() - new Date(a.DateTime).getTime())[0];
  }

  getChannels(): UserTrackerConsent[]{

    this.listCurrentStatus = []
    debugger
    const sorted = structuredClone(this.listUserTrackConsent).sort(
      (a, b) => new Date(b.DateTime).getTime() - new Date(a.DateTime).getTime()
    );

    const seenChannels = new Set<string>();

    for (const track of sorted) {
      if (!seenChannels.has(track.Channel)) {
        seenChannels.add(track.Channel);
        this.listCurrentStatus.push(track); 
      }
    }

    this.listCurrentStatus.map(x=> x.IsOptOut = x.Action == 'OptOut')

    if(this.policyHolder){
      if(this.policyHolder!.MobilePhoneNumber && !this.listCurrentStatus.some(x=> x.Channel == 'SMS'))
      this.listCurrentStatus.push(<UserTrackerConsent>{
        Channel: 'SMS',
        Value: this.policyHolder?.MobilePhoneNumber,
        consentMissing: true
      })
    
    if(this.policyHolder!.MobilePhoneNumber && !this.listCurrentStatus.some(x=> x.Channel == 'Call'))
      this.listCurrentStatus.push(<UserTrackerConsent>{
        Channel: 'Call',
        Value: this.policyHolder?.MobilePhoneNumber,
        consentMissing: true
      })
    
    if(this.policyHolder!.Email && !this.listCurrentStatus.some(x=> x.Channel == 'Mail'))
       this.listCurrentStatus.push(<UserTrackerConsent>{
        Channel: 'Mail',
        Value: this.policyHolder?.Email,
        consentMissing: true
      })
    }
    else{
      var typeSearchDetected = this.checkMatchLevel(this.form.get('searchValue')?.value);

      if(typeSearchDetected == 'phone number' && !this.listCurrentStatus.some(x=> x.Channel == 'Call')){

        this.listCurrentStatus.push(<UserTrackerConsent>{
          Channel: 'Call',
          Value: this.form.get('searchValue')?.value,
          consentMissing: true
        })      
      }

      if(typeSearchDetected == 'phone number' && !this.listCurrentStatus.some(x=> x.Channel == 'SMS')){
        this.listCurrentStatus.push(<UserTrackerConsent>{
          Channel: 'SMS',
          Value: this.form.get('searchValue')?.value,
          consentMissing: true
        })
      }
      
      if(typeSearchDetected == 'email address' && !this.listCurrentStatus.some(x=> x.Channel == 'Mail')){
       
          this.listCurrentStatus.push(<UserTrackerConsent>{
            Channel: 'Mail',
            Value: this.form.get('searchValue')?.value,
            consentMissing: true
          })
      }
    }

    console.table(this.listCurrentStatus)
    return this.listCurrentStatus.sort((a,b)=> a.Channel.localeCompare(b.Channel));

  }

  undoChanges(){
   this.listCurrentStatus.forEach(x => {
    if (x.Action === "OptIn") {
      x.IsOptOut = false;
    } else if (x.Action === "OptOut") {
      x.IsOptOut = true;
    }
    });
  }
    
  saveChanges(){
    this.isSaving = true

    // filter the changed items
    const changedItems = this.listCurrentStatus.filter(item => this.isChangedItem(item));

    if (changedItems.length === 0) {
      this.isSaving = false;
      return;
    }

    // create an array of observables for each changed item
    const requests = changedItems.map(x => {
      const optInOut: OptInOutModel = {
        actionId: x.IsOptOut ? 2 : 1,
        appId: 12,
        byCustomer: false,
        customerAppId: 'N/A',
        subApp: null, 
        values: [{
          channels: [this.getChannelId(x.Channel)],
          value: x.Value
        }],
        windowsUser: this.account.username
      };

      // get the token and send it to the optInOut request
      return this.mercuryServices.getToken().pipe(
        switchMap(token => this.mercuryServices.OptInOut(optInOut, token)),
        // capture individual errors without interrupting other requests
        catchError(err => of({ error: true, item: x, err }))
      );
    });

  // executes all requests in parallel
  forkJoin(requests).subscribe({
    next: results => {
      console.log('All requests completed.', results);
      this.isSaving = false;

      this.listUserTrackConsent = []
      this.listCurrentStatus = []

      
        this.messageService.showSuccess('Operation successfully completed!');
      
      this.listRecords()
      
    },
    error: err => {
      console.error('Error in some request.', err);
      this.messageService.showError('Something went wrong. Please try again.')
      this.isSaving = false;
    }
  });
    
  }

  getChannelId(channelName: string): number {
    switch (channelName.toUpperCase()) {
      case 'SMS':
        return 1;
      case 'CALL':
        return 2;
      case 'MAIL':
        return 3;
      default:
        return 0
    }
  }

  isChangedItem(item: UserTrackerConsent): boolean {
    return (
      (item.Action === "OptOut" && item.IsOptOut === false) ||
      (item.Action === "OptIn"  && item.IsOptOut === true)
    );
  }

  // ShowSuccessMessage(message: string) {
  //   this.snackBar.open(message, 'OK', {
  //     duration: 3000, 
  //     // horizontalPosition: 'right',
  //     // verticalPosition: 'top',
  //     panelClass: ['snackbar-success'] 
  //   });
  // }

  checkMatchLevel(cleanSearchTerm: string): string {
      const shortReg = /^[a-zA-Z0-9]{6}/g;
      const longReg = /^[a-zA-Z0-9]{9}/g;
      const emailReg = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g;
      const phoneReg = /^[0-9]*$/g;

      const regExpResults = {
        clientCodeShort: shortReg.test(cleanSearchTerm),
        clientCodeLong: longReg.test(cleanSearchTerm),
        email: emailReg.test(cleanSearchTerm),
        phone: phoneReg.test(cleanSearchTerm)
      };

      console.debug("regExp matches:", regExpResults);

      let matchLevel = '';

      if (regExpResults.clientCodeShort === true && cleanSearchTerm?.length === 6) {
        matchLevel = "client code";
      } else if (regExpResults.clientCodeLong === true && regExpResults.phone === false && cleanSearchTerm?.length === 9) {
        matchLevel = "policy code";
      } else if (regExpResults.clientCodeLong === true && regExpResults.phone === true && cleanSearchTerm?.length === 9) {
        matchLevel = "policy code/phone number";
      } else if (regExpResults.email === true) {
        matchLevel = "email address";
      } else if (regExpResults.phone === true && cleanSearchTerm?.length >= 8) {
        matchLevel = "phone number";
      } else {
        matchLevel = "no type match";
      }

      return matchLevel;
  }

  addConsent(channel: string, value: string){
     const dialogRef = this.dialog.open(EnablingNewChannelModalComponent, {
        width: '800px',
        hasBackdrop: true,
        disableClose: true,
        data: {channel, value}
      });

    dialogRef.afterClosed().subscribe(result => {
    
      if (result !== undefined) {

        this.globalLoadingService.show()
        
        var optInOut = result as OptInOutModel
        
        optInOut.windowsUser =  this.account.username
        
        this.mercuryServices.getToken().subscribe({
          next: (res: any)=>{

            this.mercuryServices.OptInOut(optInOut, res).subscribe({
              next: res=>{
               console.log('All requests completed.', res);
              this.isSaving = false;

              this.listUserTrackConsent = []
              this.listCurrentStatus = []

              this.messageService.showSuccess('Operation successfully completed!');
      
              this.listRecords()
             
              this.globalLoadingService.hide()
              
            }, 
              error: err=>{
                this.messageService.showError('Something went wrong. Please try again.')
                this.globalLoadingService.hide()
              }
            })
          }


        })

      }
    });
  }

  get canAccess(): boolean {
  const groupOk =
    !this.domainService.expectedGroupId ||
    this.auth.hasGroup(this.domainService.expectedGroupId);

  return this.auth.hasRole('Agent') && groupOk;
}


}
